import React from "react";

interface InnerCardProps {
  children: React.ReactNode;
  className?: string;
}

const InnerCard: React.FC<InnerCardProps> = ({ children, className = "" }) => (
  <div className={`inner-card-base ${className}`}>{children}</div>
);

export default InnerCard;
